import React from "react";
import styles from "./SchoolDetailsCardSkeleton.module.css";

const SchoolDetailsCardSkeleton: React.FC = () => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.schoolNameSkeleton} />
        <div className={styles.statusBadgeSkeleton} />
      </div>

      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.udiseValueSkeleton} />
          </div>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.valueSkeleton} />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.valueSkeleton} />
          </div>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.valueSkeleton} />
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.valueSkeleton} />
          </div>
          <div className={styles.field}>
            <div className={styles.labelSkeleton} />
            <div className={styles.valueSkeleton} />
          </div>
        </div>

        <div className={styles.addressSkeleton} />
      </div>
    </div>
  );
};

export default SchoolDetailsCardSkeleton;
